import useUserDataContext from '@/customHooks/useUserDataContext';
import { Navigate, Outlet, useLocation } from 'react-router';
import { pathURL } from '../constants/urls';
// import { ReactSimpleComponentProps } from '@/custom-types';

export const ProtectedRoute = () => {
  const { getUserData } = useUserDataContext()
  const userData = getUserData()
  const location = useLocation()

  if (!userData) {
    return <Navigate to={`/${pathURL.LOGIN}`} state={{ from: location }} replace />
  }

  return <Outlet />
}

/* 
export const ProtectedRoute = ({ children }: ReactSimpleComponentProps) => {
  const { getUserData, isLoading } = useUserDataContext();
  const userData = getUserData();

  if (isLoading) return <div>Cargando...</div>

  if (!userData) return <Navigate to={`/${pathURL.LOGIN}`} replace/>;

  return children;
};
 */
